import React from 'react';
import { ModalX } from '../../../components';
import { useGetRentBreakdown } from '../../../custom-hooks/use-stats';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { formatNumberWithCommas, priceToWords } from '../../../utils/functions';
import { Link } from 'react-router-dom';
import { Spinner } from '@material-tailwind/react';

const TotalRentBreakdown = ({ isOpen, onClose }) => {

    // Custom hooks
    const {
        data: rentBreakdown,
        isLoading: isRentBreakdownLoading,
        error: rentBreakdownError,
    } = useGetRentBreakdown();

    const renderUI = () => {
        if (isRentBreakdownLoading) {
            return <div className='h-[600px] flex justify-center items-center'>
                <Spinner />
            </div>;
        }
        else if (rentBreakdownError) {
            return <div>Error: {rentBreakdownError.message}</div>;
        }
        else {
            const data = rentBreakdown.customers.sort((a, b) => b.stats.monthlyRevenue - a.stats.monthlyRevenue).map((customer) => ({
                name: customer.name,
                value: customer.stats.monthlyRevenue,
            }));

            const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

            const CustomPieTooltip = ({ active, payload }) => {
                if (active && payload && payload.length) {
                    return (
                        <div className="bg-white p-2 border rounded shadow">
                            <p className={`font-medium`} style={{ color: payload[0].payload.fill }}>{`${payload[0].name}`}</p>
                            <p className="text-sm font-bold">PKR {formatNumberWithCommas(payload[0].value)}</p>
                            <p className="text-xs font-thin">{priceToWords(payload[0].value)}</p>
                            {/* <p className="text-xs">{`${(payload[0].percent * 100).toFixed(2)}%`}</p> */}
                        </div>
                    );
                }
                return null;
            };

            return (
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>

                    <div style={{ width: '100%', height: 600 }}>
                        <ResponsiveContainer >
                            <PieChart>
                                <Pie
                                    data={data}
                                    cx="100%"
                                    cy="50%"
                                    // labelLine={false}
                                    outerRadius={260}
                                    fill="#8884d8"
                                    dataKey="value"
                                    // label={({ name, value }) => `${name} - ${value}`}
                                    startAngle={90}
                                    endAngle={270}

                                >
                                    {data.map((entry, index) => (
                                        <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip content={<CustomPieTooltip />} />
                            </PieChart>

                        </ResponsiveContainer>
                    </div>
                    <div className='overflow-y-auto max-h-[600px] p-2 lg:col-span-2'>
                        <table className='w-full'>
                            <thead>
                                <tr>
                                    <th className='text-left text-xs md:text-md font-medium py-1 px-2 border'>Customer</th>
                                    <th className='text-right text-xs md:text-md font-medium py-1 px-2 border'>This Month's Rent</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rentBreakdown.customers.sort((a, b) => b.stats.monthlyRevenue - a.stats.monthlyRevenue).map((customer) => (
                                    <tr key={customer.name} className='hover:bg-gray-100'>
                                        <td className='text-left text-xs md:text-sm py-1 px-2 border'>
                                            <Link to={`/customer/${customer._id}`} className='hover:underline text-blue-500' target='_blank'>
                                                {customer.name}
                                            </Link>
                                        </td>
                                        <td className='text-right text-xs md:text-sm font-bold py-1 px-2 border'>PKR {formatNumberWithCommas(customer.stats.monthlyRevenue)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }
    }


    return (
        <ModalX title='Total Rent Breakdown' isOpen={isOpen} onClose={onClose} maxWidth='xxxl'>
            {renderUI()}
        </ModalX>
    )
};

export default TotalRentBreakdown;